import { MessageMedium } from 'constants/messageMediums';
import { Label } from 'ui/theme';
import { Link } from 'ui/links';
import { SELECTIVE_TARGETING_EMPTY_STATE_CONTENT } from './SelectiveTargeting.constants';
import { EmptyStateContainer, SelectiveTargetingSection } from './SelectiveTargeting.styled';

export interface EmptyStateProps {
  messageMedium: MessageMedium;
}

export const SelectiveTargetingEmptyState = ({ messageMedium }: EmptyStateProps) => {
  const { InApp } = MessageMedium;
  const content = SELECTIVE_TARGETING_EMPTY_STATE_CONTENT;
  const messageParts = messageMedium === InApp ? content.inApp : content.push;
  const createMobileAppLink = '/integrations/mobileApps/create';

  return (
    <EmptyStateContainer>
      <SelectiveTargetingSection>
        <Label>Destination</Label>
        <div>
          {messageParts.messagePartOne}
          <Link href={createMobileAppLink} target="_blank">
            {content.addToProject}
          </Link>
          {messageParts.messagePartTwo}
        </div>
        <div>
          <Link hasOpenNewTabIcon href={createMobileAppLink} target="_blank">
            {content.learnMore}
          </Link>
        </div>
      </SelectiveTargetingSection>
    </EmptyStateContainer>
  );
};
